import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
function transformHookRunner(hookRunnerName) {
  switch (hookRunnerName) {
    case "beforeRender":
      return "onBeforeRender";
    default:
      return hookRunnerName;
  }
}
function handleSetupResult(setupResult, api) {
  if (!setupResult) {
    return;
  }
  Object.keys(setupResult).forEach(function(key) {
    var fn = setupResult[key];
    if (typeof fn === "function") {
      var newAPI = transformHookRunner(key);
      if (api[newAPI]) {
        if (key === "beforeRender") {
          api[newAPI](/* @__PURE__ */ _async_to_generator(function() {
            var _len, params, _key;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
              switch (_state.label) {
                case 0:
                  for (_len = _arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
                    params[_key] = _arguments[_key];
                  }
                  return [
                    4,
                    fn.apply(void 0, _to_consumable_array(params))
                  ];
                case 1:
                  _state.sent();
                  return [
                    2
                  ];
              }
            });
          }));
        } else {
          api[newAPI](function() {
            for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
              params[_key] = arguments[_key];
            }
            var res = fn.apply(void 0, _to_consumable_array(params));
            return res;
          });
        }
      }
    }
  });
}
function getHookRunners(runtimeContext) {
  var _internalContext = runtimeContext._internalContext;
  var hooks = _internalContext.hooks;
  return {
    beforeRender: function() {
      var _ref = _async_to_generator(function(context) {
        return _ts_generator(this, function(_state) {
          return [
            2,
            hooks.onBeforeRender.call(context)
          ];
        });
      });
      return function(context) {
        return _ref.apply(this, arguments);
      };
    }(),
    wrapRoot: function(App) {
      return hooks.wrapRoot.call(App);
    },
    pickContext: function(context) {
      return hooks.pickContext.call(context);
    },
    modifyRuntimeConfig: function(config) {
      return hooks.modifyRuntimeConfig.call(config);
    }
  };
}
export {
  getHookRunners,
  handleSetupResult,
  transformHookRunner
};
